module.exports = __webpack_public_path__ + "img/login-eloyalfaro.edeb8d1c.svg";